export default function LogoMark({ size = 36 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="lm-g" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#FF007F" />
                    <stop offset="1" stopColor="#8B5CF6" />
                </linearGradient>
            </defs>
            <circle
                cx="32"
                cy="29"
                r="16"
                stroke="#8B5CF6"
                strokeWidth="1.6"
                strokeDasharray="4 5"
                opacity="0.7"
            />
            <rect
                x="25.5"
                y="17.5"
                width="13"
                height="21"
                rx="6.5"
                stroke="url(#lm-g)"
                strokeWidth="2.6"
            />
            <line
                x1="32"
                y1="40.5"
                x2="32"
                y2="46.5"
                stroke="url(#lm-g)"
                strokeWidth="2.6"
                strokeLinecap="round"
            />
            <path
                d="M25 47.5c1.8 2 4.3 3.2 7 3.2s5.2-1.2 7-3.2"
                stroke="url(#lm-g)"
                strokeWidth="2.4"
                strokeLinecap="round"
            />
            <line
                x1="28.5"
                y1="24"
                x2="35.5"
                y2="24"
                stroke="#FF4D9D"
                strokeWidth="1.4"
                strokeLinecap="round"
                opacity="0.9"
            />
            <line
                x1="28.5"
                y1="28.5"
                x2="35.5"
                y2="28.5"
                stroke="#FF4D9D"
                strokeWidth="1.4"
                strokeLinecap="round"
                opacity="0.9"
            />
        </svg>
    );
}
